<template>
  <create-edit-retention-policy
    :isEdit="true"
    :policyId="policyId"
    cancelRoute="Retention policies"
  />
</template>

<script>
import CreateEditRetentionPolicy from "@/components/CreateEditRetentionPolicy";

export default {
  name: "EditRetentionPolicy",
  components: {
    CreateEditRetentionPolicy,
  },
  computed: {
    policyId() {
      return Number(this.$route.params.policyId);
    },
  },
};
</script>
